import { BottomSheet, type UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useGetWorkerVisitLockStatus } from "../useGetWorkerVisitLockStatus";
import { VisitBottomSheetContent } from "./Content";
import { VisitBottomSheetFooter } from "./Footer";
import { VisitBottomSheetHeader } from "./Header";

interface VisitBottomSheetProps {
  modalState: UseModalState;
}

export function VisitBottomSheet(props: VisitBottomSheetProps) {
  const { modalState } = props;
  const { userId: workerId } = useDefinedWorker();

  const { data: lockResponse } = useGetWorkerVisitLockStatus(workerId);
  const lockedByWorkplaceId = lockResponse?.data?.attributes.lockedByWorkplaceId;

  return (
    <BottomSheet
      modalState={modalState}
      paperSx={{ height: "100%" }}
      footer={<VisitBottomSheetFooter lockedByWorkplaceId={lockedByWorkplaceId} />}
    >
      <VisitBottomSheetHeader />
      <VisitBottomSheetContent />
    </BottomSheet>
  );
}
